import { ColDef, ICellRendererParams } from "ag-grid-community";
import { MoneyCellRenderer } from "../column-def-cell-renderers/money/MoneyCellRenderer";
import { money } from "@/utils/numeral/money";

export const forecastedEOMColumnDefField = "resource.forecasted_end_of_month";

export const forecastedEOMColumnDef: ColDef = {
  minWidth: 180,
  field: forecastedEOMColumnDefField,
  headerName: "Forecasted EOM",
  headerTooltip:
    "Forecasted end-of-month cost. The forecast is based on the billing usage; if unavailable, the cost is estimated using the public listing price.",
  cellRenderer: ({ data }: ICellRendererParams) => {
    return (
      <MoneyCellRenderer
        approximate
        money={data?.resource?.forecasted_end_of_month}
      />
    );
  },
  valueGetter: ({ data }) => {
    const cost = money(data?.resource?.forecasted_end_of_month);

    if (cost === "N/A") {
      return cost;
    }

    return `~${cost}`;
  },
  comparator: (_, __, nodeA, nodeB) => {
    const current: number | undefined =
      nodeA.data?.resource?.forecasted_end_of_month;
    const next: number | undefined =
      nodeB.data?.resource?.forecasted_end_of_month;

    if (!current) return 1;
    if (!next) return -1;

    return current > next ? 1 : -1;
  },
};
